/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { toast } from "react-hot-toast"
import { DOWNLOAD_EPCC } from "../pages/DownloadScreen/graphql";

const MODULE_NAME = "DownloadEpccService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class DownloadEpccService {
    private static instance: DownloadEpccService;
    private vapp: VApplication;
    // private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        // this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): DownloadEpccService {
        if (!DownloadEpccService.instance) {
            DownloadEpccService.instance = new DownloadEpccService(props);
        }
        return DownloadEpccService.instance;
    }


    async downloadEpcc(item:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        if(!client){
            console.log('graphql-gateway is not available !!!!!!');
        }

        console.log('DownloadEpccService()::DownloadEpcc()-> entered here..');

        try {
            if (client) {
                const res = await client.query({
                    query: DOWNLOAD_EPCC,
                    variables: item,

                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "DownloadEpcc: ", res?.data);
                if (res) {
                    console.log(res?.data)
                    return res?.data;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
